export const categoriesConstants = {
    GET_CATEGORIES_REQUEST: 'GET_CATEGORIES_REQUEST',
    GET_CATEGORIES_SUCCESS: 'GET_CATEGORIES_SUCCESS',
    GET_CATEGORIES_FAILURE: 'GET_CATEGORIES_FAILURE',

    SET_OPEN_CATEGORIES_SECTIONS: 'SET_OPEN_CATEGORIES_SECTIONS'
}